import React, { useEffect } from 'react';

import './ATeamMembers.css'

import { useDispatch, useSelector } from 'react-redux';
import { getAllTeamAction } from '../../Redux/Actions/TeamAction';
import { Spinner } from 'react-bootstrap';

const ATeamMembers = () => {

    const dispatch = useDispatch()
    const isLoading = useSelector((e) => e?.LoadingReducer?.isLoading)
    const teamList = useSelector((e) => e?.TeamReducer?.teamList)

    useEffect(() => {
        getDetails()
    }, [])

    const getDetails = () => {
        // [
        //     {
        //         "id": 12,
        //         "name": "Team Members"
        //     },
        //     {
        //         "id": 11,
        //         "name": "Core Team"
        //     }
        // ]
        dispatch(getAllTeamAction(12))
    }

    const designationOrder = [
        "Senior Research Officer",
        "Senior Research Associate",
        "Research Associate I",
        "Research Associate II",
        "Account",
        "Junior Technical Assistant",
        "Junior Assistant",
        "Multi Tasking Staff",
    ];

    // Normalize spacing and compare
    const sortedData = teamList.sort((a, b) => {
        const cleanA = a.designation.trim();
        const cleanB = b.designation.trim();
        const indexA = designationOrder.indexOf(cleanA);
        const indexB = designationOrder.indexOf(cleanB);
        return indexA - indexB;
    });

    return (
        <section className="row">

            {
                isLoading ?
                    <div className='text-center'>
                        <Spinner animation="border" />
                    </div>
                    :
                    <>
                        {
                            teamList?.map((item) => (
                                <div className="col-md-6 col-lg-4 mb-4" key={item?.id}>
                                    <div className="card h-100">
                                        <div className="card-body">
                                            <img
                                                src={`https://api.coeupdspadelhi.in/uploads/${item?.image}`}
                                                className={`card-img-top ${item?.details === 'Team Leader' ? 'director-img' : 'teamMember-img'}`}
                                                alt={item?.name}
                                            />
                                            <h6 className="fw-bold">{item?.details}</h6>
                                            <p className="fw-bold mb-1 ">{item?.name}</p>
                                            <h6 className="">{item?.designation}</h6>
                                            <h6 className="">{item?.degree}</h6>
                                        </div>
                                    </div>
                                </div>
                            ))
                        }
                    </>
            }

        </section>
    );
};

export default ATeamMembers;